// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
@media print {
  .overlay-wrapper-module__overlay-wrapper___oCpEC {
    display: none;
  }
}
.overlay-wrapper-module__overlay-wrapper___oCpEC {
  position: fixed;
  width: 100%;
  z-index: 10050;
  visibility: hidden;
  bottom: 0;
  right: 0;
  left: 0;
  min-height: 1px;
  /*
   if overlay-wrapper has 0 height and width, React Portal removes the element from tab order
   https://github.com/reactjs/react-modal/issues/782
  */
  /*
   The container will be full width but we dont want it to absorb click events
   and prevent access to elements that lie underneath on the page
   */
  pointer-events: none;
}
.overlay-wrapper-module__overlay-wrapper___oCpEC > div {
  pointer-events: none;
  display: none; /* remove from tab order */
}
.overlay-wrapper-module__overlay-wrapper--actionBanner___yAEjp, .overlay-wrapper-module__overlay-wrapper--footer___wR5o7 {
  z-index: 999;
}
.overlay-wrapper-module__overlay-wrapper--visible___25oRk {
  visibility: visible;
}
.overlay-wrapper-module__overlay-wrapper--visible___25oRk > div {
  pointer-events: all;
  display: block; /* restore to tab order */
}
.overlay-wrapper-module__overlay-wrapper--animation-fade-in___MNeXZ {
  transition: 0.3s ease-out opacity;
  opacity: 0;
}
.overlay-wrapper-module__overlay-wrapper--animation-fade-in___MNeXZ.overlay-wrapper-module__overlay-wrapper--visible___25oRk {
  opacity: 1;
}
.overlay-wrapper-module__overlay-wrapper--animation-translate-from-bottom___HFgS5 {
  transform: translateY(100%); /* element must not have display: none at any time in order for the transform to work, so we apply display: none to the child element instead */
  transition: 0.3s ease-out transform;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/layouts/overlay-manager/components/overlay-wrapper/overlay-wrapper.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE;IACE,aAAA;EAMF;AACF;AAHA;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA;;;GAAA;EAKA;;;IAAA;EAIA,oBAAA;AAIF;AAFE;EACE,oBAAA;EACA,aAAA,EAAA,0BAAA;AAIJ;AADE;EAEE,YAAA;AAEJ;AACE;EACE,mBAAA;AACJ;AACI;EACE,mBAAA;EACA,cAAA,EAAA,yBAAA;AACN;AAGE;EACE,iCAAA;EACA,UAAA;AADJ;AAGI;EACE,UAAA;AADN;AAKE;EACE,2BAAA,EAEG,+IAAA;EACH,mCAAA;AALJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../../../styles/utils';\n\n@media print {\n  .overlay-wrapper {\n    display: none;\n  }\n}\n\n.overlay-wrapper {\n  position: fixed;\n  width: 100%;\n  z-index: zIndex(modal);\n  visibility: hidden;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  min-height: 1px;\n  /*\n   if overlay-wrapper has 0 height and width, React Portal removes the element from tab order\n   https://github.com/reactjs/react-modal/issues/782\n  */\n\n  /*\n   The container will be full width but we dont want it to absorb click events\n   and prevent access to elements that lie underneath on the page\n   */\n  pointer-events: none;\n\n  > div {\n    pointer-events: none;\n    display: none; /* remove from tab order */\n  }\n\n  &--actionBanner,\n  &--footer {\n    z-index: zIndex(footer);\n  }\n\n  &--visible {\n    visibility: visible;\n\n    > div {\n      pointer-events: all;\n      display: block; /* restore to tab order */\n    }\n  }\n\n  &--animation-fade-in {\n    transition: 0.3s ease-out opacity;\n    opacity: 0;\n\n    &.overlay-wrapper--visible {\n      opacity: 1;\n    }\n  }\n\n  &--animation-translate-from-bottom {\n    transform: translateY(\n      100%\n    ); /* element must not have display: none at any time in order for the transform to work, so we apply display: none to the child element instead */\n    transition: 0.3s ease-out transform;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay-wrapper": `overlay-wrapper-module__overlay-wrapper___oCpEC`,
	"overlay-wrapper--actionBanner": `overlay-wrapper-module__overlay-wrapper--actionBanner___yAEjp`,
	"overlay-wrapper--footer": `overlay-wrapper-module__overlay-wrapper--footer___wR5o7`,
	"overlay-wrapper--visible": `overlay-wrapper-module__overlay-wrapper--visible___25oRk`,
	"overlay-wrapper--animation-fade-in": `overlay-wrapper-module__overlay-wrapper--animation-fade-in___MNeXZ`,
	"overlay-wrapper--animation-translate-from-bottom": `overlay-wrapper-module__overlay-wrapper--animation-translate-from-bottom___HFgS5`
};
export default ___CSS_LOADER_EXPORT___;
